/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PaginatedCadastralLocationList,
    PaginatedCadastralLocationListFromJSON,
    PaginatedCadastralLocationListToJSON,
    PaginatedTitleDeedList,
    PaginatedTitleDeedListFromJSON,
    PaginatedTitleDeedListToJSON,
    TitleDeedDetail,
    TitleDeedDetailFromJSON,
    TitleDeedDetailToJSON,
    TitleDeedDownload,
    TitleDeedDownloadFromJSON,
    TitleDeedDownloadToJSON,
    TitleDeedPrice,
    TitleDeedPriceFromJSON,
    TitleDeedPriceToJSON,
} from '../models';

export interface DownloadTitleDeedRequest {
    titleDeedDownload?: TitleDeedDownload;
}

export interface GetTitleDeedRequest {
    id: number;
}

export interface GetTitleDeedPriceRequest {
    cadastralLocationCode?: string;
    code?: number;
    externalId?: number;
}

export interface ListCadastalLocationsRequest {
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface ListTitleDeedsRequest {
    page?: number;
    pageSize?: number;
    search?: string;
}

/**
 * TitleDeedsApi - interface
 * 
 * @export
 * @interface TitleDeedsApiInterface
 */
export interface TitleDeedsApiInterface {
    /**
     * 
     * @param {TitleDeedDownload} [titleDeedDownload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitleDeedsApiInterface
     */
    downloadTitleDeedRaw(requestParameters: DownloadTitleDeedRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    downloadTitleDeed(requestParameters: DownloadTitleDeedRequest): Promise<void>;

    /**
     * 
     * @param {number} id A unique integer value identifying this cadastral title deed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitleDeedsApiInterface
     */
    getTitleDeedRaw(requestParameters: GetTitleDeedRequest): Promise<runtime.ApiResponse<TitleDeedDetail>>;

    /**
     */
    getTitleDeed(requestParameters: GetTitleDeedRequest): Promise<TitleDeedDetail>;

    /**
     * 
     * @param {string} [cadastralLocationCode] 
     * @param {number} [code] 
     * @param {number} [externalId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitleDeedsApiInterface
     */
    getTitleDeedPriceRaw(requestParameters: GetTitleDeedPriceRequest): Promise<runtime.ApiResponse<TitleDeedPrice>>;

    /**
     */
    getTitleDeedPrice(requestParameters: GetTitleDeedPriceRequest): Promise<TitleDeedPrice>;

    /**
     * A simple ViewSet for viewing CadastralLocation.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitleDeedsApiInterface
     */
    listCadastalLocationsRaw(requestParameters: ListCadastalLocationsRequest): Promise<runtime.ApiResponse<PaginatedCadastralLocationList>>;

    /**
     * A simple ViewSet for viewing CadastralLocation.
     */
    listCadastalLocations(requestParameters: ListCadastalLocationsRequest): Promise<PaginatedCadastralLocationList>;

    /**
     * 
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TitleDeedsApiInterface
     */
    listTitleDeedsRaw(requestParameters: ListTitleDeedsRequest): Promise<runtime.ApiResponse<PaginatedTitleDeedList>>;

    /**
     */
    listTitleDeeds(requestParameters: ListTitleDeedsRequest): Promise<PaginatedTitleDeedList>;

}

/**
 * 
 */
export class TitleDeedsApi extends runtime.BaseAPI implements TitleDeedsApiInterface {

    /**
     */
    async downloadTitleDeedRaw(requestParameters: DownloadTitleDeedRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/title-deeds/download/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TitleDeedDownloadToJSON(requestParameters.titleDeedDownload),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async downloadTitleDeed(requestParameters: DownloadTitleDeedRequest): Promise<void> {
        await this.downloadTitleDeedRaw(requestParameters);
    }

    /**
     */
    async getTitleDeedRaw(requestParameters: GetTitleDeedRequest): Promise<runtime.ApiResponse<TitleDeedDetail>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTitleDeed.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/title-deeds/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TitleDeedDetailFromJSON(jsonValue));
    }

    /**
     */
    async getTitleDeed(requestParameters: GetTitleDeedRequest): Promise<TitleDeedDetail> {
        const response = await this.getTitleDeedRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getTitleDeedPriceRaw(requestParameters: GetTitleDeedPriceRequest): Promise<runtime.ApiResponse<TitleDeedPrice>> {
        const queryParameters: any = {};

        if (requestParameters.cadastralLocationCode !== undefined) {
            queryParameters['cadastral_location_code'] = requestParameters.cadastralLocationCode;
        }

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        if (requestParameters.externalId !== undefined) {
            queryParameters['external_id'] = requestParameters.externalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/title-deeds/price/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TitleDeedPriceFromJSON(jsonValue));
    }

    /**
     */
    async getTitleDeedPrice(requestParameters: GetTitleDeedPriceRequest): Promise<TitleDeedPrice> {
        const response = await this.getTitleDeedPriceRaw(requestParameters);
        return await response.value();
    }

    /**
     * A simple ViewSet for viewing CadastralLocation.
     */
    async listCadastalLocationsRaw(requestParameters: ListCadastalLocationsRequest): Promise<runtime.ApiResponse<PaginatedCadastralLocationList>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page-size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/title-deeds/cadastral-locations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedCadastralLocationListFromJSON(jsonValue));
    }

    /**
     * A simple ViewSet for viewing CadastralLocation.
     */
    async listCadastalLocations(requestParameters: ListCadastalLocationsRequest): Promise<PaginatedCadastralLocationList> {
        const response = await this.listCadastalLocationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listTitleDeedsRaw(requestParameters: ListTitleDeedsRequest): Promise<runtime.ApiResponse<PaginatedTitleDeedList>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page-size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/title-deeds/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTitleDeedListFromJSON(jsonValue));
    }

    /**
     */
    async listTitleDeeds(requestParameters: ListTitleDeedsRequest): Promise<PaginatedTitleDeedList> {
        const response = await this.listTitleDeedsRaw(requestParameters);
        return await response.value();
    }

}
